import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodySM } from "@/domains/design/components/body-sm"
import { formatCurrency } from "@/domains/library"

interface VenammCompleteProps {
  store: VenammSellStore
  governanceTokenSymbol?: string
}

export const VenammComplete = observer(
  ({ store, governanceTokenSymbol = "SCALE" }: VenammCompleteProps) => {
    if (!store.lock || !store.quote) return null

    return (
      <MultilineMessageBox variant="success" icon={<MessageBoxIcon size={"md"} variant="success" />}>
        <BodySM className="text-success-text">
          Successfully sold NFT #{store.lock.id} for {formatCurrency(store.quote.value)} {governanceTokenSymbol} 🎉
        </BodySM>
        <div className="flex items-center justify-start gap-2">
          {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" className="mt-2" />}
          {store.approveTxHash && (
            <ExternalTxLink url={store.approveTxHashUrl} title="View approve tx" className="mt-2" />
          )}
          {store.sellTxHash && <ExternalTxLink url={store.sellTxHashUrl} title="View sell tx" className="mt-2" />}
        </div>
      </MultilineMessageBox>
    )
  },
)

